export const GET_REQUEST = 'GET_REQUEST'
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS'
export const ERROR_REQUEST = 'ERROR_REQUEST'
export const GET_TOKEN = 'GET_TOKEN'
export const GET_LISTADOS = 'GET_LISTADOS'
export const GET_EMPRESA = 'GET_EMPRESA'
export const GET_LISTADOS_COMPUESTOS = "GET_LISTADOS_COMPUESTOS"
export const ADD_INSTRUCTIONS = "ADD_INSTRUCTIONS"
export const ACTUALIZAR = "ACTUALIZAR"
export const ADD_ITEM = "ADD_ITEM"
export const MOD_SEC = "MOD_SEC"
